<template>
  <v-card height="100%">
    <area-chart
      :library="{ title: 'Survey responses over time' }"
      adapter="google"
      :data="responsesOverTime()"
      :messages="{ empty: 'No data' }"
    />
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "ResponseOverTime",
  computed: {
    ...mapState({
      selectedSurvey: state => state.survey.selectedSurveyNumber,
      responses: state =>
        state.charts.charts.filter(response => {
          return response.survey === state.survey.selectedSurveyNumber;
        })
    })
  },
  methods: {
    responsesOverTime() {
      let times = [];
      const countResponses = arr => {
        return arr.reduce((count, word) => {
          count[word] = (count[word] || 0) + 1;
          return count;
        }, {});
      };
      const timeStamps = (array, format) => {
        return array.map(response => {
          return moment(response.timestamp)
            .local()
            .format(format);
        });
      };
      const asDay = "YYYY-MM-DD";
      const asHour = "YYYY-MM-DD HH:00:00 ZZ";
      const asMinute = "YYYY-MM-DD HH:mm:00 ZZ";
      times = countResponses(timeStamps(this.responses, asDay));
      // `times` is now an object and each key/value is every unique day with the number of responses

      // Basically, this fires if there are only responses for one day
      if (Object.keys(times).length === 1) {
        times = countResponses(timeStamps(this.responses, asHour));
      }
      // Now each key/value is every unique hour with number of responses

      // Basically, this fires if there are only responses for one hour
      if (Object.keys(times).length === 1) {
        times = countResponses(timeStamps(this.responses, asMinute));
      }
      // Now each key/value is every unique minute with number of responses
      return times;
    }
  }
};
</script>